import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import Tooltip from './../utils/Tooltip'

// State
import {
	removeCartProduct,
	removeCartCoupon,
	removeCartDonation,
	clearDeleteMsg,
} from '../../store/actions/cart'

// Util
const { removeFromCart: removeFromCartGA } = require('../../utils/google-analytics')

class DeleteCell extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	componentWillMount() {
		this.props.clearDeleteMsg()
	}

	handleItemDelete(item, type) {
		switch (type) {
			case 'coupon':
				this.props.removeCartCoupon(item.id)
				break
			case 'donation':
				this.props.removeCartDonation(item.id)
				break
			case 'product':
				// this.handleCouponAutoRemove(item);
				this.props.removeCartProduct(item.id)
				removeFromCartGA(item)
				break
			default:
				break
		}
	}

	handleCouponDelete(coupon) {
		this.props.removeCartCoupon(coupon.id)
	}

	//REMOVES COUPON IF THE CART TOTAL WOULD BE LOWER THAN THE COUPON REQUIREMENT
	handleCouponAutoRemove(product) {
		if (this.props.codes.length) {
			const code = this.props.codes[0]
			const productTotalToLose = product.price * product.qty
			const cartTotal = this.props.cart.cart_summary.total_price
			const couponMin = this.props.codes.length ? code.min_sale_amount : 0
			const newTotal = cartTotal - productTotalToLose
			if (newTotal < couponMin) {
				this.handleCouponDelete(code)
			}
		}
	}

	render() {
		let error = null
		if (this.props.deleteError && this.props.deletedId === this.props.item.id) {
			error = (
				<Tooltip
					parent={this.tooltipParentName}
					type={'dialog--error'}
					messageObjects={[this.props.deleteError]}
					closeAction={this.props.clearDeleteMsg}
				/>
			)
		}

		return (
			<div className=''>
				{error}
				<div
					className='icon-cross delete-btn'
					ref={tooltipParentName => (this.tooltipParentName = tooltipParentName)}
					onClick={() => this.handleItemDelete(this.props.item, this.props.type)}
				/>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		cart: state.cart,
		items: state.cart.items,
		codes: state.cart.codes,
		deleteSuccess: state.cart.deleteSuccess,
		deleteError: state.cart.deleteError,
		deletedId: state.cart.deletedId,
		deleteInProcess: state.cart.deleteInProcess,
	}
}

export default connect(mapStateToProps, {
	removeCartProduct,
	removeCartCoupon,
	removeCartDonation,
	clearDeleteMsg,
})(DeleteCell)



// WEBPACK FOOTER //
// ./src/components/cart/DeleteCell.js